module.exports = __webpack_public_path__ + "static/media/laser_icon.eaec6628.svg";